export const TOPICS_FETCH = 'TOPICS_FETCH';
export const TOPICS_FETCH_SUCCESS = 'TOPICS_FETCH_SUCCESS';
export const TOPICS_FETCH_ERROR = 'TOPICS_FETCH_ERROR';
export const topicsFetch = (topicsType, categoryId) => ({type: TOPICS_FETCH, topicsType, categoryId});

export const TOPIC_UPDATE = 'TOPIC_UPDATE';
export const TOPIC_UPDATE_SUCCESS = 'TOPIC_UPDATE_SUCCESS';
export const TOPIC_UPDATE_ERROR = 'TOPIC_UPDATE_ERROR';
export const topicUpdate = (id, updates) => ({type: TOPIC_UPDATE, id, updates});

export const TOPIC_UPDATE_REVERT = 'TOPIC_UPDATE_REVERT';
export const topicUpdateRevert = (id, updates) => ({type: TOPIC_UPDATE_REVERT, id, updates});



/** WEBPACK FOOTER **
 ** ./src/members/state/topics/actions.js
 **/